import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from 'react-query';
import {
  ResidentAccountSummary,
  ResidentAccountBookmark,
  ResidentFavoriteModel,
} from 'src/api/models';
import 'src/api/resident-application';
import {
  fetchResidentBookmarksService,
  fetchResidentFavorites,
  fetchResidentLeasesService,
  updateResidentFavorite,
} from 'src/api/residents';
import { useUser } from '../users/useUser';

export function useResidentLeases(
  options?: UseQueryOptions<ResidentAccountSummary>,
) {
  return useQuery<ResidentAccountSummary>(
    'residents/summary',
    () => fetchResidentLeasesService(),
    options,
  );
}

export function useResidentBookmarks(
  options?: UseQueryOptions<ResidentAccountBookmark>,
) {
  return useQuery<ResidentAccountBookmark>(
    'residents/tours-apps',
    () => fetchResidentBookmarksService(),
    options,
  );
}

export function useResidentFavorites() {
  const { user } = useUser();
  const { userId } = user || {};
  const { isLoading, error, data } = useQuery<ResidentFavoriteModel[]>(
    'residents/favorites',
    () => fetchResidentFavorites(),
    {
      enabled: !!userId,
    },
  );
  return {
    favorites: data,
    isFavoritesLoading: isLoading,
    favoritesError: error,
  };
}

export function useUpdateResidentFavorite() {
  const queryClient = useQueryClient();
  const { isLoading, mutateAsync } = useMutation(updateResidentFavorite, {
    onSuccess: () => {
      queryClient.invalidateQueries('residents/favorites');
    },
  });

  return { isUpdatingFavorite: isLoading, updateFavorite: mutateAsync };
}
